import {useEffect, useRef} from 'react'

import moment from 'moment'

// TODO: Change name, functions works with strings and Date objects.
export const combineDateAndTimeStrings = (dateStr, timeStr) => {
  let date = moment(dateStr, 'YYYY-MM-DD')

  return moment(timeStr, ['HH:mm:ss.S', 'YYYY-MM-DD HH:mm:ss.S'])
    .year(date.year())
    .month(date.month())
    .date(date.date())
    .toDate()
}

export const formatTime = (time, format) =>
  moment(time, ['HH:mm:ss.S', 'YYYY-MM-DD HH:mm:ss.S']).format(format)

export const getDateFromString = ({dateStr, format = 'YYYY-MM-DD'} = {}) =>
  moment(dateStr, format).toDate()

export const isToday = dateStr => {
  let today = moment()
  let date = moment(dateStr, 'YYYY-MM-DD')

  return today.isSame(date, 'd')
}

export const formatDate = (dateStr, format) =>
  moment(dateStr, 'YYYY-MM-DD').format(format)

export const formatDateAndTime = dateStr => {
  let formattedTime = formatDate(dateStr, 'LT')
  let ampm = formattedTime.substring(formattedTime.length - 2)
  if (ampm === 'am' || ampm === 'pm' || ampm === 'AM' || ampm === 'PM') {
    formattedTime = formattedTime.substring(0, formattedTime.length - 3)
  } else {
    ampm = ''
  }

  return {
    time: formattedTime,
    ampm,
    date: formatDate(dateStr, 'dddd, MMMM D')
  }
}

export const formatTimeWithMeridiem = ({date}) => {
  let ampm
  let formattedTime = formatDate(date, 'LT')
  ampm = formattedTime.substring(formattedTime.length - 2)
  if (ampm === 'am' || ampm === 'pm' || ampm === 'AM' || ampm === 'PM') {
    formattedTime = formattedTime.substring(0, formattedTime.length - 3)
  }

  return {
    time: formattedTime,
    ampm
  }
}

export const useInterval = (callback, delay) => {
  const savedCallback = useRef(null)

  useEffect(
    () => {
      savedCallback.current = callback
    },
    [callback]
  )

  useEffect(
    () => {
      const tick = () => savedCallback.current()

      if (delay !== null) {
        let timerId = setInterval(tick, delay)
        return () => clearInterval(timerId)
      }
    },
    [delay]
  )
}

/**
 * Checks if the supplied Date objects have the same date. The time portion of the Date object is ignored
 * @param {Date} d1
 * @param {Date} d2
 * @returns {boolean} True if the dates are equal
 */
export const isSameDate = (d1, d2) => {
  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getDate() === d2.getDate() &&
    d1.getMonth() === d2.getMonth()
  )
}

/**
 * Returns a Date object with the time portion set to 0
 * @param {Date} d
 * @returns {Date}
 */
export const getDate = d =>
  new Date(d.getFullYear(), d.getMonth(), d.getDate(), 0, 0, 0)

/**
 * Returns the first day of the month for the provided date
 * @param {Date} d
 * @returns {Date} Date set to the first day of the month.
 */
export const getFirstDayOfMonth = d =>
  new Date(d.getFullYear(), d.getMonth(), 1)

export const convertTimeStringToNumber = timeString => {
  let [hourStr, minutesStr] = timeString.split(':')
  let hours = parseInt(hourStr)
  let minutes = parseInt(minutesStr)
  let roundedMinutes = minutes >= 30 ? 0.5 : 0

  return hours + roundedMinutes
}

export const convertTimeNumberToString = ({timeNumber, format = 'HH:mm'}) => {
  let minutes = timeNumber * 60
  let d = new Date(1900, 0, 1, 0, 0, 0)
  d.setMinutes(d.getMinutes() + minutes)

  return formatTime(d, format)
}

export const convertTimeNumberToDate = ({date, timeNumber}) => {
  let minutes = timeNumber * 60
  let d = new Date(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)

  d.setMinutes(d.getMinutes() + minutes)

  return d
}


export const parseTime = ({time}) =>
  moment(time, ['HH:mm:ss.S', 'YYYY-MM-DD HH:mm:ss.S']).toDate()
